
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import config from '@/config'
import banner from '@/assets/survey/bg2.png'
import { getSurveyQuestion, postSurvey } from '@/api/youzheng'
import { getCityYzwj, getJdYzwj } from '@/api/sys.js'
export default {
name: 'quesAsk',
components: {
XTextarea,
XDialog,
Msg,
Toast,
XButton,
XInput,
Group,
PopupPicker
},
data () {
return {
baseUrl: config.baseUrl,
banner: banner,
list: [],
listAll: [],
listDom: null,
moreshow: true,
suTitle: '',
Answer: {},
Textarea: {},
Textshow: {},
Textholder: {},
timuID: [],
timuIndex: 0,
timuAnswer: [],
person: {
acctname: '', // 姓名
workaddress: '', // 单位
mobile: '', // 联系电话
birthprovinceid: 1,
birthcityid: '',
birthcountyid: ''
},
birthcity_id: [],
addressValue: [31, '', 1],
isShow: false,
citylist: [],
jdlist: [],
jdlist_id: [],
tipsList: [
{
title: 1,
tips: '企业经营步入良性循环，各项指标比去年有所提高优化。'
},
{
title: 2,
tips: '把“两个维护”体现在坚决贯彻党中央决策部署的行动上,体现在履职尽责、做好本职工 作的实效上,体现在党员、干部的日常言行上。'
},
{
title: 3,
tips: '扎实开展党史学习教育和纪念建党百年活动；领导干部带头讲党课，理论水平高。'
},
{
title: 4,
tips: '急难险重任务目前，党员领导干部身先士卒，做好表率；广泛开展党员“三亮三比三评”活动，比学赶帮超。'
},
{
title: 5,
tips: '为员工办实事、办好事、解难事，努力提高职工福利待遇，改善生产条件，关心员工身心健康。'
},
{
title: 6,
tips: '深入基层，联系群众，真抓实干，脚踏实地；持续纠治形式主义、官僚主义，不说空话假话套话。'
},
{
title: 7,
tips: '部门协作顺畅，不推诿不扯皮，齐心协力，内耗少。'
},
{
title: 8,
tips: '坚持德才兼备标准选人用人，抓好优秀年轻干部的培养；发挥各个年龄段人员的作用，把人用在合适的岗位上，人尽其才，物尽其用。'
},
{
title: 9,
tips: '制度设计科学合理，实施过程公正公开，员工服气。'
},
{
title: 10,
tips: '加强执纪监督。认真查处靠邮吃邮、设租寻租等腐败问题和偷逃邮件重量、挪用资金、邮件丢失等问题，常态化开展纪律教育，引导党员干部严守党的六大纪律。'
}
]
}
},
created () {
this.getList()
this.getCityid()
this.getJdid()
},
computed: {
},
mounted () {
this.listDom = this.$el.querySelector('.paper .cont>ul')
},
watch: {
birthcity_id () {
this.person.birthcityid = this.birthcity_id[0]
}





},
methods: {
getList () {
getSurveyQuestion({
paperid: this.$route.params.type
}).then(res => {
this.listAll = res.returnValue.ROWLIST
this.suTitle = res.returnValue.TITLE
this.listAll.forEach((item, index) => {
if (item.ROWTYPE == 2) {
item.ROWLIST.forEach((res, ind) => {
this.timuID[this.timuIndex++] = res.SUBJECTID
if (index == 1) {
res.tips = this.tipsList[ind].tips
}
})
} else {
this.timuID[this.timuIndex++] = item.SUBJECTID
}
})
})
},
bodyScroll (event) {
event.preventDefault()
},
stopScroll () {
document.body.style.overflow = 'hidden'
document.addEventListener('touchmove', this.bodyScroll, { passive: false })
},
startScroll () {
document.body.style.overflow = ''
document.removeEventListener('touchmove', this.bodyScroll, false)
},
getCityid () {
var _this = this
getCityYzwj({
plistvalue: this.person.birthprovinceid
}).then(data => {
data.obj.forEach(element => {
if (element.key != '') {
_this.citylist.push({
name: element.value,
value: element.key + ''
})
}
})
})
},
getJdid () {
var _this = this
getJdYzwj({
addTreeNode: 1
}).then(data => {
data.obj.forEach(element => {
if (element.key != '') {
_this.jdlist.push({
name: element.value,
value: element.key + ''
})
}
})
})
},
checkText (id, istk, textholder) {
if (istk == 1) {
this.Textshow[id] = true
this.Textholder[id] = textholder
} else {
this.Textshow[id] = false
}
},
close_dia () {
this.isShow = false
this.startScroll()
},
postAdd () {


console.log(this.countProperties(this.Answer))
if (Object.keys(this.Answer).length < this.timuIndex) {
this.$vux.toast.text('问卷未填完！', 'middle')
return
}
for (let key in this.Textshow) {
console.log(key + '---' + this.Textshow[key])
if (this.Textshow[key]) {
if (this.Textarea[key] == '' || this.Textarea[key] == null) {
this.$vux.toast.text('请填写理由！', 'middle')
return
}
}
}

this.isShow = true
this.stopScroll()
this.timuAnswer = []
this.timuID.forEach((item, index) => {

if (this.Textshow[item]) {
this.timuAnswer[index] = { subjectid: item, optionList: [{ optionid: this.Answer[item], tkcontent: this.Textarea[item] }] }





} else {
this.timuAnswer[index] = { subjectid: item, optionList: [{ optionid: this.Answer[item] }] }
}
})


},
countProperties (obj) {
var count = 0
for (var property in obj) {
if (Object.prototype.hasOwnProperty.call(obj, property)) {
count++
}
}
return count
},
endAdd () {
if (this.person.acctname === '') {
this.$vux.toast.text('请输入用户姓名！', 'middle')
this.$refs.acctname.focus()
return false
}
if (this.addressValue.length === 0) {
this.$vux.toast.text('请选择所在地区！', 'middle')
return false
}
let myreg = /^1[3456789]\d{9}$/
if (this.person.mobile === '') {
this.$vux.toast.text('请输入联系电话！', 'middle')
this.$refs.mobile.focus()
return false
} else if (!myreg.test(this.person.mobile)) {
this.$vux.toast.text('请输入正确的手机号', 'middle')
this.$refs.mobile.focus()
return false
}
if (this.person.workaddress === '') {
this.$vux.toast.text('请输入工作单位！', 'middle')
this.$refs.workaddress.focus()
return false
}
postSurvey({
paperid: this.$route.params.type,
mobile: this.person.mobile,
acctname: this.person.acctname,
unitname: this.person.workaddress,
provinceid: this.person.birthprovinceid,
cityid: this.person.birthcityid,
countyid: this.person.birthcountyid,
submitList: JSON.stringify(this.timuAnswer),
baseid: this.jdlist_id[0]
}).then(res => {
this.$vux.toast.show({ text: '问卷信息已提交，谢谢', time: '2500', position: 'middle' })
this.startScroll()
let _this = this
window.setTimeout(function () {
_this.$router.push({ name: 'yzQuestion', params: { type: _this.$route.params.activityid } })
}, 1500)
})
}
}
}
